/* @fflow */
import React from 'react';
import { THead, Tr, Th } from '../../UIKit/Table';

export default function UploadFilesColumns() {
  return (
    <THead>
      <Tr>
        <Th style={{ width: `14rem` }}>Filename</Th>
        <Th style={{ width: `3.5rem` }}>Size</Th>
        <Th style={{ width: `5rem` }}>Last Modified</Th>
        <Th style={{ width: `1.5rem`, textAlign: `center` }}>Remove</Th>
      </Tr>
    </THead>
  );
}
